import { IconBox, IconCloudUpload, IconReload, IconX, IconTrash, IconDeviceFloppy, IconCamera, IconPhoto, IconSearch, IconInfoCircle, IconDiamond } from '@tabler/icons-react';
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { CurrencyInput } from '../../utils/CurrencyInput';
import { DinamicTitle } from '../../utils/DinamicTitle';
import imageCompression from 'browser-image-compression';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import Webcam from 'react-webcam';
import useKarat from '../features/useKarat';
import useBaki from '../features/useBaki';

function TambahBarang() {
  DinamicTitle('Tambah Barang || Komaladewi');
  const navigate = useNavigate();
  const [kategori, setKategori] = useState([]);
  const [jenis_kategori_id, setJeniKategoriId] = useState('');
  const [berat, setBerat] = useState('');
  const [berat_potongan_mata, setBeratPotonganMata] = useState('');
  const [ukuran, setUkuran] = useState('');
  const [karat, setKarat] = useState('');
  // const [cabang_id, setCabangId] = useState('');
  const [cabang, setCabang] = useState([]);
  const [jenisKategori, setJenisKategori] = useState([]);
  const [harga_modal, setHargaModal] = useState(0);
  const [skemaModal, setSkemaModal] = useState('manual'); // 'manual' | 'total'
  const [harga_total, setHargaTotal] = useState('');
  const [gambar1, setGambar1] = useState('');
  const [gambar1Url, setGambar1Url] = useState('');
  const [nomor_rak, setNomerRak] = useState('');
  const [selectImage, setSelectImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const webcamRef = React.useRef(null);

  const [kategoriId, setKategoriId] = useState('');
  
  const [isOpenJenisModal, setIsOpenJenisModal] = useState(false);
  const [searchJenis, setSearchJenis] = useState('');
  const [isOpenBakiModal, setIsOpenBakiModal] = useState(false);
  const [searchBaki, setSearchBaki] = useState('');
  const [isOpenKaratModal, setIsOpenKaratModal] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  // Input berat sebagai pembagi harga modal skema pembelian (tanpa mengurangi berat mata)
  const beratInput = useMemo(() => {
    return parseFloat(berat) || 0;
  }, [berat]);

  // Otomatis hitung harga modal bila menggunakan skema total pembelian
  useEffect(() => {
    if (skemaModal === 'total') {
      if (beratInput > 0 && Number(harga_total) > 0) {
        setHargaModal(Math.round(Number(harga_total) / beratInput));
      } else {
        setHargaModal(0);
      }
    }
  }, [skemaModal, harga_total, beratInput]);

  const isFormValid = useMemo(() => {
    return (
      kategoriId !== '' &&
      jenis_kategori_id !== '' &&
      berat !== '' &&
      karat !== '' &&
      nomor_rak !== '' &&
      Number(harga_modal) > 0 &&
      gambar1 !== '' &&
      (skemaModal === 'manual' || (Number(harga_total) > 0 && beratInput > 0))
    );
  }, [kategoriId, jenis_kategori_id, berat, karat, nomor_rak, harga_modal, gambar1, skemaModal, harga_total, beratInput]);

  useEffect(() => {
    const roleCheck = localStorage.getItem('role');
    if (roleCheck === 'operator') {
      toast.error('Akses ditolak: Role operator tidak memiliki izin untuk menambah barang.');
      navigate('/');
    }
  }, [navigate]);


  useEffect(() => {
    async function getCabang() {
      await http
        .get('/cabang', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          }
        });
    }
    getCabang();
  }, []);

  useEffect(() => {
    async function getKategori() {
      await http
        .get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          // console.log('res::: ', res);
          setKategori(res.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getKategori();
  }, [navigate]);

  function resetForm() {
    setJeniKategoriId('');
    setBerat('');
    setBeratPotonganMata('');
    setUkuran('');
    setKarat('');
    setHargaModal(0);
    setGambar1('');
    setGambar1Url('');
    setNomerRak('');
    setSelectImage([]);
    setKategoriId('');
    setJenisKategori([]);
    setSkemaModal('manual');
    setHargaTotal('');
  }

  useEffect(() => {
    const regex = /^\d*\.?\d{0,3}$/;
    if (berat && !regex.test(berat)) {
      setBerat(berat.slice(0, -1));
    }
  }, [berat]);

  useEffect(() => {
    const regex = /^\d*\.?\d{0,3}$/;
    if (berat_potongan_mata && !regex.test(berat_potongan_mata)) {
      setBeratPotonganMata(berat_potongan_mata.slice(0, -1));
    }
  }, [berat_potongan_mata]);

  const handleImageChange = async (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);

    if (selectImage.length < 1) {
      const file = selectedFiles[0];

      // Options for image compression
      const options = {
        maxSizeMB: 1, // Maximum size in MB
        maxWidthOrHeight: 1024, // Maximum width or height
        useWebWorker: true, // Use web worker for better performance
      };

      try {
        const compressedFile = await imageCompression(file, options);
        console.log('Ukuran file setelah kompresi:', (compressedFile.size / 1024).toFixed(2), 'KB');

        const reader1 = new FileReader();
        reader1.addEventListener('load', function () {
          setGambar1(reader1.result.split(',')[1]);
          setGambar1Url(reader1.result);
        });
        reader1.readAsDataURL(compressedFile);

        const compressedImageURL = URL.createObjectURL(compressedFile);
        setSelectImage([compressedImageURL]);
      } catch (error) {
        console.error('Error compressing image:', error);
      }
    } else {
      const imagesArray = selectedFilesArray.map((file) => {
        return URL.createObjectURL(file);
      });
      setSelectImage(imagesArray);
    }

    // FOR BUG IN CHROME
    event.target.value = '';
  };

  function deleteHandler(image) {
    setSelectImage(selectImage.filter((e) => e !== image));
    URL.revokeObjectURL(image);
    setGambar1('');
    setGambar1Url('');
  }

  const capture = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      try {
        const res = await fetch(imageSrc);
        const blob = await res.blob();
        const file = new File([blob], 'webcam.jpg', { type: 'image/jpeg' });

        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        const reader1 = new FileReader();
        reader1.addEventListener('load', function () {
          setGambar1(reader1.result.split(',')[1]);
          setGambar1Url(reader1.result);
        });
        reader1.readAsDataURL(compressedFile);

        const compressedImageURL = URL.createObjectURL(compressedFile);
        setSelectImage([compressedImageURL]);
        setIsCameraOpen(false);
      } catch (error) {
        console.error('Error compressing webcam image:', error);
      }
    }
  }, [webcamRef]);

  function handleSubmitItem(e) {
    e.preventDefault();
    if (!isFormValid) {
      toast.warning('Lengkapi semua data wajib termasuk foto barang sebelum menyimpan.', { autoClose: 800 });
      return;
    }
    if (harga_modal === 0 || harga_modal === '0') {
      toast.error('Input harga modal tidak boleh kosong', { autoClose: 600 });
      return;
    }
    setIsConfirmModalOpen(true);
  }

  async function executeSubmitItem() {
    setIsConfirmModalOpen(false);
    try {
      setLoading(true);
      let finalGambar1 = gambar1;

      // Tambahkan Frame Canvas jika gambar1 ada
      if (gambar1) {
        try {
          finalGambar1 = await new Promise((resolve) => {
            const img = new Image();
            const timer = setTimeout(() => resolve(gambar1), 1500); // Timeout 1.5s
            
            img.onload = () => {
              clearTimeout(timer);
              try {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                
                // Gambar foto asli
                ctx.drawImage(img, 0, 0);

                // Atur style teks
                const fontSize = Math.max(14, Math.floor(canvas.width / 28)); // <-- Ubah angka 28 ini untuk mengecilkan/membesarkan teks
                ctx.font = `bold ${fontSize}px sans-serif`;
                
                // Ambil Nama Jenis Item
                const namaJenis = jenis_kategori_id ? jenisKategori.find(j => String(j.id) === String(jenis_kategori_id))?.nama_jenis : '';
                
                // Background text (transparan)
                ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
                const padding = fontSize * 0.7; // <-- Ubah jarak bingkai
                
                // Background Atas
                ctx.fillRect(0, 0, canvas.width, fontSize + padding * 2);
                
                // Background Bawah
                const bottomHeight = namaJenis ? (fontSize * 2 + padding * 2.2) : (fontSize + padding * 2);
                ctx.fillRect(0, canvas.height - bottomHeight, canvas.width, bottomHeight);
                
                // Gambar Teks putih -> diubah jadi GOLD (#FFD700)
                ctx.fillStyle = '#FFD700';
                
                // Teks Atas Kiri: Ukuran
                ctx.textAlign = 'left';
                if (ukuran) {
                  ctx.fillText(`Ukuran: ${ukuran}`, padding, padding + fontSize * 0.85);
                }
                
                // Teks Atas Kanan: Karat
                ctx.textAlign = 'right';
                if (karat) {
                  ctx.fillText(`Kadar: ${karat} Karat`, canvas.width - padding, padding + fontSize * 0.85);
                }
                
                // Teks Bawah Kanan: Nama Jenis & Berat
                ctx.textAlign = 'right';
                if (namaJenis) {
                  ctx.fillText(namaJenis, canvas.width - padding, canvas.height - bottomHeight + padding + fontSize * 0.85);
                  ctx.fillText(`Berat: ${berat} gr${berat_potongan_mata ? ` | Berat Mata: ${berat_potongan_mata} gr` : ""}`, canvas.width - padding, canvas.height - padding * 0.9);
                } else {
                  ctx.fillText(`Berat: ${berat} gr${berat_potongan_mata ? ` | Berat Mata: ${berat_potongan_mata} gr` : ""}`, canvas.width - padding, canvas.height - padding * 0.9);
                }
                
                // Ambil base64 tanpa prefix
                const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
                resolve(dataUrl.split(',')[1]);
              } catch (err) {
                resolve(gambar1);
              }
            };
            img.onerror = () => {
              clearTimeout(timer);
              resolve(gambar1);
            };
            img.src = gambar1Url || ('data:image/jpeg;base64,' + gambar1);
          });
        } catch (err) {
          console.error('Gagal menambahkan frame watermark:', err);
        }
      }

      const response = await http.post(
        `/item`,
        {
          jenis_kategori_id,
          berat,
          karat,
          nomor_rak,
          harga_modal,
          // cabang_id,
          berat_potongan_mata,
          ukuran,
          gambar1: finalGambar1,
        },
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      );
      toast.success('Data berhasil disimpan', { autoClose: 600 });
      setLoading(false);
      resetForm();
      return response.data;
    } catch (error) {
      toast.warning('Silahkan ganti gambar', { autoClose: 600 });
      if (error.response?.status === 401) {
        navigate('/login');
      } else if (error.response?.status === 422) {
        toast.warning('Lengkapi input data', { autoClose: 600 });
      } else if (error.code === 'ERR_NETWORK') {
        toast.warning('Periksa jaringan internet', { autoClose: 600 });
      }
    }
    setLoading(false);
  }

  async function selectJenisKategori(id) {
    setKategoriId(id);
    setJeniKategoriId('');
    await http
      .get(`/jenis/kategori/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setJenisKategori(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const { karatOption } = useKarat();

  const { bakiOption } = useBaki();

  return (
    <Layouts
      compFilter={
        <button
          onClick={() => window.location.reload()}
          className="bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 p-2 text-slate-700 dark:text-slate-200 rounded-md transition"
          title="Refresh halaman"
        >
          <IconReload />
        </button>
      }
    >
      <div className="mx-auto max-w-4xl">
        <div className="bg-white dark:bg-slate-900 sm:shadow-sm sm:border border-slate-200 dark:border-slate-800 sm:rounded-xl">
          {/* Header */}
          <div className="relative overflow-hidden px-4 py-4 sm:px-6 border-b border-slate-200 dark:border-slate-800 bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-transparent">
            {/* Background Accent Element */}
            <div className="absolute top-0 right-0 -mr-12 -mt-12 w-48 h-48 rounded-full bg-amber-500/10 blur-3xl pointer-events-none"></div>
            
            <div className="relative flex items-center gap-3.5">
              <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-br from-amber-400 to-amber-600 shadow-md shadow-amber-500/20 text-white">
                <IconBox size={20} stroke={2} />
              </div>
              <div className="flex flex-col justify-center">
                <h2 className="text-lg sm:text-xl font-bold leading-none bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
                  Tambah Barang
                </h2>
              </div>
            </div>
          </div>

          <div className="px-4 py-5 sm:p-6 pb-36 sm:pb-6">
            <form onSubmit={handleSubmitItem} className="space-y-6">

              {/* === Section: Kategori === */}
              <div className="space-y-5">
                <div className="relative">
                  <select
                    value={kategoriId}
                    onChange={(e) => { if (e.target.value) selectJenisKategori(e.target.value); else { setKategoriId(''); setJenisKategori([]); setJeniKategoriId(''); } }}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih Kategori</option>
                    {kategori.map((item) => (
                      <option key={item.id} value={item.id}>{item.nama_kategori}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Kategori</label>
                </div>

                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setIsOpenJenisModal(true)}
                    disabled={!kategoriId}
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer disabled:bg-slate-50 dark:disabled:bg-slate-900 disabled:text-slate-400 dark:disabled:text-slate-600 disabled:cursor-not-allowed flex items-center justify-between text-left"
                  >
                    <span className="truncate">
                      {jenis_kategori_id 
                        ? jenisKategori.find(j => String(j.id) === String(jenis_kategori_id))?.nama_jenis || 'Pilih Jenis Kategori' 
                        : 'Pilih Jenis Kategori'}
                    </span>
                    <IconSearch size={16} className="text-slate-400 shrink-0" />
                  </button>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Jenis Kategori</label>
                </div>
              </div>

              {/* === Divider === */}
              {/* <div className="border-t border-slate-100"></div> */}

              {/* === Section: Detail Barang === */}
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setIsOpenBakiModal(true)}
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer flex items-center justify-between text-left transition-all hover:border-amber-400 group"
                  >
                    <span className={`truncate ${nomor_rak !== '' ? 'font-bold text-slate-800 dark:text-slate-100' : 'text-slate-400 dark:text-slate-500 font-normal'}`}>
                      {nomor_rak !== '' ? `Baki #${nomor_rak}` : 'Pilih Baki'}
                    </span>
                    <IconBox size={18} className="text-amber-500 shrink-0 ml-1 group-hover:scale-110 transition-transform" />
                  </button>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                    Nomor BAKI
                  </label>
                </div>

                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setIsOpenKaratModal(true)}
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer flex items-center justify-between text-left transition-all hover:border-amber-400 group"
                  >
                    <span className={`truncate ${karat !== '' ? 'font-bold text-slate-800 dark:text-slate-100' : 'text-slate-400 dark:text-slate-500 font-normal'}`}>
                      {karat !== '' ? `${karat} Karat` : 'Pilih Karat'}
                    </span>
                    <IconDiamond size={18} className="text-amber-500 shrink-0 ml-1 group-hover:scale-110 transition-transform" />
                  </button>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                    Karat
                  </label>
                </div>
              </div>

              {/* === Divider === */}
              {/* <div className="border-t border-slate-100"></div> */}
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    placeholder='2.350'
                    type="number"
                    step="0.001"
                    inputMode="decimal"
                    id="berat"
                    autoComplete="off"
                    value={berat}
                    onChange={(e) => setBerat(e.target.value)}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                  />
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Berat Bersih (gr)</label>
                  {/* <p className="text-xs text-slate-400 mt-1.5">Input sesuai format</p> */}
                </div>

                <div className="relative">
                  <input
                    placeholder='0.350'
                    type="number"
                    step="0.001"
                    inputMode="decimal"
                    id="berat_potongan_mata"
                    autoComplete="off"
                    value={berat_potongan_mata}
                    onChange={(e) => setBeratPotonganMata(e.target.value)}
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                  />
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Berat Mata (gr)</label>
                </div>
              </div>

              {/* === Section: Ukuran / Size === */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                <div className="relative">
                  <input
                    placeholder='Contoh: 15 / M / L'
                    type="text"
                    id="ukuran"
                    autoComplete="off"
                    value={ukuran}
                    onChange={(e) => setUkuran(e.target.value)}
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                  />
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Ukuran / Size (Opsional)</label>
                </div>
              </div>

              {/* === Section: Skema Input Harga Modal === */}
              <div className="mt-4 mb-4 p-3.5 sm:p-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 space-y-3">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5">
                  <div>
                    <span className="text-xs sm:text-sm font-bold text-slate-800 dark:text-slate-200">
                      Harga Modal Barang
                    </span>
                    <p className="text-[11px] text-slate-500 dark:text-slate-400">
                      Pilih skema input harga modal barang
                    </p>
                  </div>
                  <div className="inline-flex rounded-xl p-1 bg-slate-200/80 dark:bg-slate-700/80 self-start sm:self-auto w-full sm:w-auto">
                    <button
                      type="button"
                      onClick={() => setSkemaModal('manual')}
                      className={`flex-1 sm:flex-initial px-3 py-1.5 text-xs font-bold rounded-lg transition-all ${
                        skemaModal === 'manual'
                          ? 'bg-white dark:bg-slate-800 text-amber-600 dark:text-amber-400 shadow-xs'
                          : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
                      }`}
                    >
                      1.Manual (/gr)
                    </button>
                    <button
                      type="button"
                      onClick={() => setSkemaModal('total')}
                      className={`flex-1 sm:flex-initial px-3 py-1.5 text-xs font-bold rounded-lg transition-all ${
                        skemaModal === 'total'
                          ? 'bg-white dark:bg-slate-800 text-amber-600 dark:text-amber-400 shadow-xs'
                          : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
                      }`}
                    >
                      2.Pembelian
                    </button>
                  </div>
                </div>

                {skemaModal === 'manual' ? (
                  <div className="relative pt-1">
                    <CurrencyInput
                      name="harga_modal"
                      value={harga_modal}
                      autoComplete="off"
                      onChange={(value) => setHargaModal(() => value)}
                      className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                    />
                    <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-800 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                      Harga Modal / Gram (Rp)
                    </label>
                  </div>
                ) : (
                  <div className="space-y-3 pt-1">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="relative">
                        <CurrencyInput
                          name="harga_total"
                          value={harga_total}
                          autoComplete="off"
                          placeholder="Contoh: 5.000.000"
                          onChange={(value) => setHargaTotal(() => value)}
                          className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                        />
                        <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-800 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                          Nominal Total Pembelian (Rp)
                        </label>
                      </div>

                      <div className="relative">
                        <input
                          type="text"
                          readOnly
                          value={Number(harga_modal) > 0 ? `Rp ${Number(harga_modal).toLocaleString('id-ID')} / gr` : 'Rp 0 / gr'}
                          className="w-full h-14 sm:h-12 border border-slate-200 dark:border-slate-700 bg-slate-100/90 dark:bg-slate-900/70 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm font-bold text-amber-600 dark:text-amber-400 rounded-lg cursor-not-allowed"
                        />
                        <label className="absolute -top-2.5 left-3 bg-slate-100 dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                          Modal / Gram (Otomatis)
                        </label>
                      </div>
                    </div>

                    {/* Breakdown / Info Box */}
                    <div className="p-3 rounded-xl bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800/40 text-xs text-amber-900 dark:text-amber-200 flex flex-col sm:flex-row sm:items-center justify-between gap-1.5">
                      <div>
                        Berat Pembagi:{' '}
                        <strong>{beratInput > 0 ? beratInput.toFixed(3) : '0'} gr</strong>
                      </div>
                      {beratInput <= 0 ? (
                        <span className="text-rose-600 dark:text-rose-400 font-medium">
                          *Isi berat barang untuk menghitung modal
                        </span>
                      ) : Number(harga_total) > 0 ? (
                        <div className="font-semibold text-amber-800 dark:text-amber-300">
                          Rp {Number(harga_total).toLocaleString('id-ID')} ÷ {beratInput.toFixed(3)} gr ={' '}
                          <span className="underline">Rp {Number(harga_modal).toLocaleString('id-ID')}/gr</span>
                        </div>
                      ) : (
                        <span className="text-slate-500 dark:text-slate-400">
                          *Masukkan total harga beli
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* === Divider === */}
              {/* <div className="border-t border-slate-100"></div> */}

              {/* === Section: Foto === */}
              <div className="bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-800 p-4 sm:p-5 rounded-lg">
                <p className="text-sm font-semibold text-slate-700 dark:text-slate-300">
                  {selectImage.length > 0 ? 'Foto Barang (1/1 Terpilih)' : 'Foto Barang (Wajib 1 Foto)'}
                </p>

                {isCameraOpen ? (
                  <div className="mt-4 flex flex-col items-center gap-3">
                    <div className="relative w-full max-w-sm rounded-lg overflow-hidden border-2 border-amber-500">
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={{ facingMode: "environment" }}
                        className="w-full object-cover"
                      />
                      <button
                        type="button"
                        onClick={() => setIsCameraOpen(false)}
                        className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1.5 shadow-md z-10 active:scale-90 transition-transform"
                      >
                        <IconX width={16} />
                      </button>
                    </div>
                    <button
                      type="button"
                      onClick={capture}
                      className="px-6 py-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-full shadow-lg flex items-center gap-2"
                    >
                      <IconCamera className="w-5 h-5" />
                      Ambil Foto
                    </button>
                  </div>
                ) : selectImage.length > 0 ? (
                  <div className="mt-4 flex items-center gap-3 overflow-x-auto pb-2">
                    {selectImage.map((image, index) => (
                      <div key={index} className="relative flex-shrink-0">
                        <button
                          type="button"
                          onClick={() => deleteHandler(image)}
                          className="absolute -top-2 -right-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-full p-1.5 shadow-md z-10 active:scale-90 transition-transform"
                        >
                          <IconX width={16} className="dark:text-slate-200" />
                        </button>
                        <PhotoProvider>
                          <PhotoView src={image}>
                            <img
                              className="h-24 w-24 sm:h-20 sm:w-20 rounded-lg border border-slate-200 dark:border-slate-700 object-cover bg-white dark:bg-slate-900 cursor-pointer"
                              src={image}
                              alt="Preview"
                              title="Klik untuk memperbesar gambar"
                            />
                          </PhotoView>
                        </PhotoProvider>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="mt-4 grid grid-cols-3 gap-2">
                    <button
                      type="button"
                      onClick={() => setIsCameraOpen(true)}
                      className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 h-16 sm:h-11 bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 border-2 border-amber-200 dark:border-amber-800/50 hover:bg-amber-100 dark:hover:bg-amber-900/30 active:bg-amber-200 dark:active:bg-amber-900/40 text-xs sm:text-sm font-semibold cursor-pointer transition rounded-lg"
                    >
                      <IconCamera className="w-5 h-5" />
                      Webcam
                    </button>
                    <label className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 h-16 sm:h-11 bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 border-2 border-amber-200 dark:border-amber-800/50 hover:bg-amber-100 dark:hover:bg-amber-900/30 active:bg-amber-200 dark:active:bg-amber-900/40 text-xs sm:text-sm font-semibold cursor-pointer transition rounded-lg">
                      <IconCamera className="w-5 h-5" />
                      Kamera HP
                      <input
                        type="file"
                        onChange={handleImageChange}
                        accept="image/png,image/jpeg,image/webp"
                        capture="environment"
                        className="hidden"
                      />
                    </label>
                    <label className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 h-16 sm:h-11 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-2 border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 active:bg-slate-100 dark:active:bg-slate-600 text-xs sm:text-sm font-semibold cursor-pointer transition rounded-lg">
                      <IconPhoto className="w-5 h-5" />
                      Galeri
                      <input
                        type="file"
                        onChange={handleImageChange}
                        accept="image/png,image/jpeg,image/webp"
                        className="hidden"
                      />
                    </label>
                  </div>
                )}
              </div>

              <div className="fixed sm:static bottom-0 left-0 right-0 p-4 sm:p-0 bg-white dark:bg-slate-900 sm:bg-transparent border-t sm:border-t-0 border-slate-200 dark:border-slate-800 sm:border-transparent shadow-[0_-4px_12px_rgba(0,0,0,0.08)] sm:shadow-none z-40 sm:z-auto">
                <div className="max-w-4xl mx-auto">
                  <button
                    type="submit"
                    disabled={loading || !isFormValid}
                    className="w-full h-14 sm:h-11 px-6 text-base sm:text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 active:to-amber-700 rounded-xl sm:rounded-lg shadow-lg shadow-amber-500/20 disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed disabled:shadow-none transition-all flex items-center justify-center gap-2"
                  >
                    <IconDeviceFloppy className="w-5 h-5" />
                    {loading ? 'Proses...' : 'Simpan'}
                  </button>
                </div>
              </div>

              {loading && (
                <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
                  <div className="w-12 h-12 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
      
      {/* Jenis Kategori Modal */}
      {isOpenJenisModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-md shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col max-h-[80vh]">
            <div className="p-4 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-800/50">
              <h3 className="font-bold text-slate-800 dark:text-slate-200">Pilih Jenis Kategori</h3>
              <button onClick={() => setIsOpenJenisModal(false)} className="text-slate-400 hover:text-red-500 transition-colors">
                <IconX size={20} />
              </button>
            </div>
            <div className="p-4 border-b border-slate-100 dark:border-slate-700">
              <div className="relative">
                <IconSearch size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  placeholder="Cari jenis kategori..."
                  value={searchJenis}
                  onChange={(e) => setSearchJenis(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                  autoFocus
                />
              </div>
            </div>
            <div className="overflow-y-auto p-2">
              {jenisKategori.filter(item => item.nama_jenis.toLowerCase().includes(searchJenis.toLowerCase())).length > 0 ? (
                jenisKategori.filter(item => item.nama_jenis.toLowerCase().includes(searchJenis.toLowerCase())).map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    onClick={() => {
                      setJeniKategoriId(item.id);
                      setIsOpenJenisModal(false);
                      setSearchJenis('');
                    }}
                    className={`w-full text-left px-4 py-3 rounded-xl mb-1 transition-colors text-sm font-medium flex items-center justify-between ${
                      String(jenis_kategori_id) === String(item.id) 
                      ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400' 
                      : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700'
                    }`}
                  >
                    {item.nama_jenis}
                    {String(jenis_kategori_id) === String(item.id) && <div className="w-2 h-2 rounded-full bg-amber-500"></div>}
                  </button>
                ))
              ) : (
                <div className="text-center py-8 text-sm text-slate-500">Jenis kategori tidak ditemukan</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Pilih Baki */}
      {isOpenBakiModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-md shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col max-h-[85vh]">
            <div className="p-4 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-800/50">
              <div className="flex items-center gap-2.5">
                <div className="p-2 bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 rounded-xl">
                  <IconBox size={20} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-800 dark:text-slate-100 text-base">Pilih Nomor BAKI</h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400">Pilih salah satu nomor baki etalase</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => {
                  setIsOpenBakiModal(false);
                  setSearchBaki('');
                }}
                className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
              >
                <IconX size={20} />
              </button>
            </div>

            {/* Pencarian Baki (jika pilihan baki banyak) */}
            {bakiOption.length > 8 && (
              <div className="p-3 border-b border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800">
                <div className="relative">
                  <IconSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input
                    type="text"
                    placeholder="Cari nomor baki..."
                    value={searchBaki}
                    onChange={(e) => setSearchBaki(e.target.value)}
                    className="w-full pl-9 pr-8 py-2 border border-slate-200 dark:border-slate-700 rounded-lg bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-500 text-xs sm:text-sm"
                  />
                  {searchBaki && (
                    <button
                      type="button"
                      onClick={() => setSearchBaki('')}
                      className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                    >
                      <IconX size={14} />
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* Grid Pilihan Baki */}
            <div className="overflow-y-auto p-4 max-h-[60vh]">
              <div className="grid grid-cols-3 sm:grid-cols-4 gap-2.5">
                {bakiOption
                  .filter((b) => !searchBaki || String(b).includes(searchBaki.trim()))
                  .map((item) => {
                    const isSelected = String(nomor_rak) === String(item);
                    return (
                      <button
                        key={item}
                        type="button"
                        onClick={() => {
                          setNomerRak(Number(item));
                          setIsOpenBakiModal(false);
                          setSearchBaki('');
                        }}
                        className={`h-14 rounded-xl flex flex-col items-center justify-center font-bold text-sm transition-all cursor-pointer ${
                          isSelected
                            ? 'bg-amber-500 text-white shadow-lg shadow-amber-500/30 ring-2 ring-amber-400 scale-[1.02]'
                            : 'bg-slate-50 dark:bg-slate-700/60 hover:bg-amber-50 dark:hover:bg-amber-950/40 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-slate-600 hover:border-amber-400'
                        }`}
                      >
                        <span className="text-[10px] uppercase font-semibold opacity-70 leading-none mb-0.5">Baki</span>
                        <span className="text-base font-extrabold leading-none">#{item}</span>
                      </button>
                    );
                  })}
              </div>
              {bakiOption.filter((b) => !searchBaki || String(b).includes(searchBaki.trim())).length === 0 && (
                <div className="text-center py-8 text-sm text-slate-400">Nomor baki tidak ditemukan</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Pilih Karat */}
      {isOpenKaratModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-md shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col max-h-[85vh]">
            <div className="p-4 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-800/50">
              <div className="flex items-center gap-2.5">
                <div className="p-2 bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 rounded-xl">
                  <IconDiamond size={20} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-800 dark:text-slate-100 text-base">Pilih Kadar Karat</h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400">Pilih tingkat kemurnian / karat perhiasan</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setIsOpenKaratModal(false)}
                className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
              >
                <IconX size={20} />
              </button>
            </div>

            {/* Grid Pilihan Karat */}
            <div className="overflow-y-auto p-4 max-h-[60vh]">
              <div className="grid grid-cols-3 gap-3">
                {karatOption.map((item) => {
                  const isSelected = Number(karat) === Number(item);
                  return (
                    <button
                      key={item}
                      type="button"
                      onClick={() => {
                        setKarat(Number(item));
                        setIsOpenKaratModal(false);
                      }}
                      className={`h-16 rounded-xl flex flex-col items-center justify-center gap-1 transition-all cursor-pointer ${
                        isSelected
                          ? 'bg-gradient-to-br from-amber-500 to-amber-600 text-white shadow-lg shadow-amber-500/30 ring-2 ring-amber-400 scale-[1.02]'
                          : 'bg-slate-50 dark:bg-slate-700/60 hover:bg-amber-50 dark:hover:bg-amber-950/40 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-slate-600 hover:border-amber-400'
                      }`}
                    >
                      <IconDiamond size={18} className={isSelected ? 'text-white' : 'text-amber-500'} />
                      <span className="text-sm font-extrabold leading-none">{item} K</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {isConfirmModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-md shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col">
            <div className="p-5 border-b border-slate-100 dark:border-slate-700 bg-amber-50 dark:bg-amber-900/20 flex items-start gap-3">
              <div className="p-2 bg-amber-100 dark:bg-amber-900/40 rounded-full text-amber-600 dark:text-amber-400 shrink-0 mt-0.5">
                <IconInfoCircle size={24} />
              </div>
              <div>
                <h3 className="font-bold text-md text-amber-800 dark:text-amber-400">Konfirmasi Simpan Barang</h3>
              </div>
            </div>
            <div className="p-5 space-y-3 max-h-[60vh] overflow-y-auto">
              <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                <span className="text-slate-500 dark:text-slate-400">Jenis Kategori</span>
                <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">{kategoriId ? kategori.find(k => String(k.id) === String(kategoriId))?.nama_kategori : '-'} - {jenis_kategori_id ? jenisKategori.find(j => String(j.id) === String(jenis_kategori_id))?.nama_jenis : '-'}</span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                <span className="text-slate-500 dark:text-slate-400">Baki</span>
                <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">{nomor_rak}</span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                <span className="text-slate-500 dark:text-slate-400">Karat</span>
                <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">{karat}</span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                <span className="text-slate-500 dark:text-slate-400">Berat Bersih</span>
                <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">{berat} gr</span>
              </div>
              {ukuran && (
                <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                  <span className="text-slate-500 dark:text-slate-400">Ukuran</span>
                  <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">{ukuran}</span>
                </div>
              )}
              {berat_potongan_mata && (
                <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                  <span className="text-slate-500 dark:text-slate-400">Berat Mata</span>
                  <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">{berat_potongan_mata} gr</span>
                </div>
              )}
              <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                <span className="text-slate-500 dark:text-slate-400">Skema Modal</span>
                <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">
                  {skemaModal === 'total' ? 'Dari Total Pembelian' : 'Input Manual (/gr)'}
                </span>
              </div>
              {skemaModal === 'total' && Number(harga_total) > 0 && (
                <div className="grid grid-cols-2 gap-2 text-sm border-b border-slate-100 dark:border-slate-700 pb-2">
                  <span className="text-slate-500 dark:text-slate-400">Total Pembelian</span>
                  <span className="font-semibold text-slate-800 dark:text-slate-200 text-right">Rp {Number(harga_total).toLocaleString('id-ID')}</span>
                </div>
              )}
              <div className="grid grid-cols-2 gap-2 text-sm">
                <span className="text-slate-500 dark:text-slate-400">Harga Modal / Gram</span>
                <span className="font-semibold text-amber-600 dark:text-amber-400 text-right">Rp {Number(harga_modal).toLocaleString('id-ID')}</span>
              </div>
            </div>
            <div className="p-4 border-t border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 flex gap-3 justify-end">
              <button 
                type="button"
                onClick={() => setIsConfirmModalOpen(false)} 
                className="px-5 py-2 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-lg transition-colors"
                disabled={loading}
              >
                Batal
              </button>
              <button 
                type="button"
                onClick={executeSubmitItem} 
                className="px-5 py-2 text-sm font-medium text-white bg-amber-500 hover:bg-amber-600 rounded-lg shadow-sm transition-colors flex items-center gap-2 disabled:opacity-50"
                disabled={loading}
              >
                {loading ? 'Menyimpan...' : 'Ya, Simpan'}
                {!loading && <IconDeviceFloppy size={18} />}
              </button>
            </div>
          </div>
        </div>
      )}

    </Layouts>
  );
}

export default TambahBarang;
